exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  height: 3px;\n  overflow: hidden;\n  z-index: 1010; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/loading/loading.component.scss
// module id = 907
// module chunks = 0